import { render, staticRenderFns } from "./AdminInboundDeliveryDetails.vue?vue&type=template&id=c686e2e4&scoped=true"
import script from "./AdminInboundDeliveryDetails.vue?vue&type=script&lang=js"
export * from "./AdminInboundDeliveryDetails.vue?vue&type=script&lang=js"
import style0 from "./AdminInboundDeliveryDetails.vue?vue&type=style&index=0&id=c686e2e4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c686e2e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c686e2e4')) {
      api.createRecord('c686e2e4', component.options)
    } else {
      api.reload('c686e2e4', component.options)
    }
    module.hot.accept("./AdminInboundDeliveryDetails.vue?vue&type=template&id=c686e2e4&scoped=true", function () {
      api.rerender('c686e2e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inbound/AdminInboundDeliveryDetails.vue"
export default component.exports